import {jsx} from 'panel';

import {ButtonTheme} from 'common/components/button/constants';
import {SvgIconEl} from 'common/components/svg-icon';
import {QueryBlockEl} from 'common/query-builder/query-block';
import {SelectorType} from 'common/query-builder/query-block/constants';
import {propertyItemToSegmentation} from 'common/query-builder/query-block/properties-menu/util';
import {QueryEntrySectionEl} from 'common/query-builder/query-entry-section';
import {RowLabelType} from 'common/query-builder/query-entry-section/types';
import {PropertyType} from 'common/report/constants';

import type {RHSPanel} from '../index';
import {TemplateField} from '../types';
import {FieldLabel} from './FieldLabel';

export const EventAndListPropertySelector = (
  modal: RHSPanel, // TODO(RHS): change variable name
  eventName: string,
  propertyName: string,
  propertyKey: string,
  label: string,
  disabled: boolean,
  tooltipText: string,
) => {
  const propertyFriendlyBorderRadius = modal.state.fields[eventName] ? `border-radius: 9px 9px 0 0` : ``;

  return (
    <div sel='.event-mapping-row.short-field'>
      {FieldLabel(label, tooltipText)}
      {/* Event selector */}
      <div>
        <QueryEntrySectionEl
          attrs={{
            disabled,
            'add-entry-label': `Select Events and Properties`,
            'add-entry-button-label': `Select Events and Properties`,
            'project-id': parseInt(modal.getContext(`currentProject`).id, 10),
            theme: ButtonTheme.QueryBuilder,
            'track-name': `templates`,
            selected: modal.state.fields[eventName],
            'disable-add-event-filters': true,
            'disable-clone-entry': true,
            'disable-delete-entry': false,
            'disable-first-time-event-filters': true,
            'row-limit': 1,
            'row-label-type': RowLabelType.None,
            'row-label-prefix-icon': `event`,
            'style-override': `.mp-query-entry-section.for-new-ui .mp-query-entry-section-footer, .mp-query-entry-section.for-new-ui .mp-query-entry{margin-left: 0px; width: 100%; ${propertyFriendlyBorderRadius}} :host(:not(.contained-section)) .mp-query-entry-section.for-new-ui .mp-query-add-entry-row mp-button:not(.is-open){opacity: 0.7;}`,
          }}
          on={{
            update: (ev: CustomEvent) => {
              if (ev.detail.entries.length) {
                modal.helpers.updateField(ev.detail.updatedEntry.event, eventName as TemplateField);
              } else {
                modal.helpers.removeField(eventName as TemplateField);
                modal.helpers.removeField(propertyName as TemplateField);
                modal.helpers.removeField(propertyKey as TemplateField);
              }
            },
            click: () => modal.update(),
          }}
          hook={{
            insert: ({elm}) => modal.setElRef(eventName, elm),
          }}
        />
      </div>

      {modal.state.fields[eventName] && (
        // List property selector
        <div sel='.property-selector'>
          <div sel='.list-property'>
            <SvgIconEl sel='.property-icon' attrs={{icon: `type-list`}} />
            <QueryBlockEl
              attrs={{
                type: `properties`,
                'project-id': parseInt(modal.getContext(`currentProject`).id, 10),
                'selector-type': SelectorType.Button,
                'selector-icon': ``,
                theme: ButtonTheme.QueryBuilder,
                selected: modal.state.fields[propertyName],
                'type-filter': [PropertyType.List],
                'event-names': [modal.state.fields[eventName].value],
                'style-override': `.mp-query-block-selector-inner{padding: 3px 3px 3px 0;}`,
              }}
              on={{
                select: (ev: CustomEvent) => {
                  modal.helpers.updateField(ev.detail.item, propertyName as TemplateField);
                  modal.helpers.removeField(propertyKey as TemplateField);
                },
                click: () => modal.update(),
              }}
              hook={{
                insert: ({elm}) => modal.setElRef(propertyName, elm),
              }}
            />
          </div>
          {modal.state.fields[propertyName] && (
            // List property key selector
            <div>
              <QueryBlockEl
                attrs={{
                  type: `properties`,
                  'project-id': parseInt(modal.getContext(`currentProject`).id, 10),
                  'selector-type': SelectorType.Button,
                  theme: ButtonTheme.QueryBuilder,
                  'selector-icon': modal.state.fields[propertyKey]
                    ? modal.state.fields[propertyKey].type === `string`
                      ? `type-text`
                      : `type-${modal.state.fields[propertyKey].type}`
                    : ``,
                  selected: modal.state.fields[propertyKey],
                  'style-override': `.mp-query-block-selector-inner{padding: 3px 3px 3px 20px; width: fit-content;}`,
                }}
                params={{
                  listProperty: propertyItemToSegmentation(
                    modal.state.fields[propertyName],
                    modal.state.fields[propertyName]?.resourceType,
                  ),
                }}
                on={{
                  select: (ev: CustomEvent) => modal.helpers.updateField(ev.detail.item, propertyKey as TemplateField),
                  click: () => modal.update(),
                }}
                hook={{
                  insert: ({elm}) => modal.setElRef(propertyKey, elm),
                }}
              />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
